module.exports = __webpack_public_path__ + "img/22.b2c4111a.jpg";